export interface DeviceInfo {
  browser: string;
  browserVersion: string;
  os: string;
  osVersion: string;
  deviceType: 'Desktop' | 'Mobile' | 'Tablet';
  fullUserAgent: string;
}

export const parseUserAgent = (userAgent: string | null): DeviceInfo => {
  if (!userAgent) {
    return {
      browser: 'Onbekend',
      browserVersion: '',
      os: 'Onbekend',
      osVersion: '',
      deviceType: 'Desktop',
      fullUserAgent: '',
    };
  }

  const ua = userAgent;

  // Detect browser
  let browser = 'Onbekend';
  let browserVersion = '';

  if (ua.includes('Edg/')) {
    browser = 'Edge';
    browserVersion = ua.match(/Edg\/([\d.]+)/)?.[1] || '';
  } else if (ua.includes('Chrome/') && !ua.includes('Edg/')) {
    browser = 'Chrome';
    browserVersion = ua.match(/Chrome\/([\d.]+)/)?.[1] || '';
  } else if (ua.includes('Firefox/')) {
    browser = 'Firefox';
    browserVersion = ua.match(/Firefox\/([\d.]+)/)?.[1] || '';
  } else if (ua.includes('Safari/') && !ua.includes('Chrome')) {
    browser = 'Safari';
    browserVersion = ua.match(/Version\/([\d.]+)/)?.[1] || '';
  } else if (ua.includes('Opera/') || ua.includes('OPR/')) {
    browser = 'Opera';
    browserVersion = ua.match(/(?:Opera|OPR)\/([\d.]+)/)?.[1] || '';
  }

  // Detect OS
  let os = 'Onbekend';
  let osVersion = '';

  if (ua.includes('Windows NT')) {
    os = 'Windows';
    const version = ua.match(/Windows NT ([\d.]+)/)?.[1];
    if (version === '10.0') osVersion = '10';
    else if (version === '6.3') osVersion = '8.1';
    else if (version === '6.2') osVersion = '8';
    else if (version === '6.1') osVersion = '7';
    else osVersion = version || '';
  } else if (ua.includes('Mac OS X')) {
    os = 'macOS';
    osVersion = ua.match(/Mac OS X ([\d_]+)/)?.[1]?.replace(/_/g, '.') || '';
  } else if (ua.includes('Linux')) {
    os = 'Linux';
  } else if (ua.includes('Android')) {
    os = 'Android';
    osVersion = ua.match(/Android ([\d.]+)/)?.[1] || '';
  } else if (ua.includes('iOS') || ua.includes('iPhone') || ua.includes('iPad')) {
    os = 'iOS';
    osVersion = ua.match(/OS ([\d_]+)/)?.[1]?.replace(/_/g, '.') || '';
  }

  // Detect device type
  let deviceType: 'Desktop' | 'Mobile' | 'Tablet' = 'Desktop';
  if (ua.includes('Mobile') || ua.includes('Android')) {
    deviceType = 'Mobile';
  } else if (ua.includes('Tablet') || ua.includes('iPad')) {
    deviceType = 'Tablet';
  }

  return {
    browser,
    browserVersion: browserVersion.split('.')[0], // Only major version
    os,
    osVersion,
    deviceType,
    fullUserAgent: ua,
  };
};
